(() => {
  if (window.cmDisclosuresReady) return;
  window.cmDisclosuresReady = true;
  const media = window.matchMedia('(max-width: 749px)');
  function init(scope = document) {
    scope.querySelectorAll('details[data-cm-mobile-disclosure]').forEach(details => {
      if (details.dataset.cmDisclosureReady) return;
      details.dataset.cmDisclosureReady = 'true';
      details.open = !media.matches;
    });
  }
  function sync() {
    document.querySelectorAll('details[data-cm-mobile-disclosure]').forEach(details => { details.open = !media.matches; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), {once:true});
  else init();
  media.addEventListener('change', sync);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
